@if (!iframeUrl) {
  <div>
    <button (click)="analyze('basic')" type="button" [disabled]="loading || iframeUrl"
            class="button mr-3 mb-2" [ngClass]="{'button_disabled': loading || iframeUrl}">
      Быстрый анализ
    </button>
    <button (click)="analyze('full')" type="button" [disabled]="loading || iframeUrl"
            class="button mr-3 mb-2" [ngClass]="{'button_disabled': loading || iframeUrl}">
      Глубокий анализ
    </button>
    <button (click)="analyze('iframe')" type="button" [disabled]="loading || iframeUrl"
            class="button mb-2" [ngClass]="{'button_disabled': loading || iframeUrl}">
      Внешний анализ с фильтрами
    </button>
  </div>
  @if (analyzeResult) {
    <div class="col-12 mt-5">
      @if (analyzeResult.status_code) {
        <div>
          Код ответа: <b>{{ analyzeResult.status_code }}</b>
        </div>
      }
      @if (analyzeResult.headers) {
        <div>
          Заголовки:
          <pre>{{ analyzeResult.headers }}</pre>
        </div>
      }
      @if (analyzeResult.analyze_content) {
        <div>
          Анализ:
          @if (analyzeFilter) {
            <div class="my-3">
              <app-alert-warning>
                <div><i class="fa-fw fa fa-warning"></i> <b>Внимание!</b> Установлен фильтр!</div>
                @for (el of analyzeFilter; track el) {
                  <div class="mt-2">
                    {{ el[0] }}: {{ el[1] }}
                  </div>
                }
              </app-alert-warning>
            </div>
          }
          <!--          <pre>{{analyzeResult.analyze_content}}</pre>-->
          @for (lvl1 of analyzeResult.analyze_content; track lvl1) {
            <div>
              {{ lvl1.selector }}
              <ul>
                @for (lvl2 of lvl1.content; track lvl2) {
                  <li>
                    `{{ lvl2.value }}`:
                    <!--          <ng-container *ngIf="lvl2.canFilter">-->
                    <!--            <a href="javascript:void(0)"-->
                    <!--               (click)="analyze('full', [lvl1.selector, lvl2.value])"-->
                    <!--            >{{lvl2.result}}<span class="ml-4">[фильтр]</span></a>-->
                    <!--          </ng-container>-->
                    <!--          <ng-container *ngIf="!lvl2.canFilter">-->
                    {{ lvl2.result }}
                    <!--          </ng-container>-->
                  </li>
                }
              </ul>
              <!--            -->
              <!--            <div *ngFor="let v2 of v1; index as key2">-->
              <!--              {{key2}} {{v2}-->
              <!--            </div>-->
            </div>
          }
        </div>
      }
    </div>
  }
} @else {
  <iframe [src]="iframeUrl"></iframe>
}
